<!--Section for General Information -->
<div id="generalInformationSection">
  <h5 class="p-16 m-0 bottomBorderStyle">General Information</h5>
  <div class="generalInformationContent input-min-spacing p-16 genInfo-height enableScroll gen-Info-height">
    @if (clickedBucketItem !== null) {
      <div class="form-label p-b-xs">Name</div>
    }
    @if (clickedBucketItem !== null) {
      <div class="form-value p-b-m row-container horizontal-center-align h-2rem icon-color">
      <img class="icon-layout p-r-s" [src]="
          clickedBucketItem?.Type === 'Folder'
            ? 'assets/images/bucket-icons/icon-folder.svg'
            : 'assets/images/bucket-icons/icon-file.svg'
        " alt="file/folder img" />
          <div class="flexCenterAlign">
            <div class="content-general-information width-14vw" matTooltipClass="tooltip-style" matTooltipPosition="above"
              appMatTooltip="{{clickedBucketItem?.LeafName}}"
              [attr.id]="buildControlId('lbl-leaf-name')">
              {{ clickedBucketItem?.LeafName }}
            </div>
            @if (
              clickedBucketItem?.StudyCompletionDate === null &&
              clickedBucketItem?.IsConsideredForTransfer === true &&
              clickedBucketItem?.IsChecked
              ) {
              <div
                [matTooltip]="'Study Completion Date is not available'"
                matTooltipClass="tooltip-style"
                matTooltipPosition="above"
                [attr.id]="buildControlId('icon-study-completion-warning')"
                >
                <span class="icon-ic-warning p-l-xs color-warning cursor"></span>
              </div>
            }
            @if (
              clickedBucketItem?.ChecksumStatus === 'VerifiedAndCorrupted'
              ) {
              <div
                [matTooltip]="checksum_fail_tooltip"
                matTooltipClass="tooltip-style"
                matTooltipPosition="above"
                [attr.id]="buildControlId('icon-checksum-warning')"
                >
                <span  class="icon-ic-warning p-l-xs color-error cursor"></span>
              </div>
            }
          </div>
        </div>
      }

      <div (mouseover)="hideChecksumIcons(false)" (mouseleave)="hideChecksumIcons(true)">
        @if (clickedBucketItem) {
          <div class="form-label p-b-xs">Checksum (SHA-512)</div>
        }
        @if (clickedBucketItem) {
          <div class="form-value p-b-m row-container horizontal-center-align h-20 icon-color">
            @if (clickedBucketItem.FolderType === 'File' && clickedBucketItem.StreamHash && clickedBucketItem.ChecksumStatus !== 'NotVerified') {
              <span class="content-general-information" matTooltipClass="tooltip-style" matTooltipPosition="above"
                appMatTooltip="{{clickedBucketItem?.StreamHash}}"
                [attr.id]="buildControlId('lbl-checksum-value', 'verified')">
                {{ clickedBucketItem?.StreamHash }}
              </span>
            }
            @if (clickedBucketItem.FolderType === 'File' && clickedBucketItem.StreamHash && clickedBucketItem.ChecksumStatus === 'NotVerified') {
              <span class="greylight">
                Verifying checksum...
              </span>
            }
            @if (clickedBucketItem.FolderType !== 'File') {
              <span class="content-general-information">
                N/A
              </span>
            }
            @if (
              clickedBucketItem.FolderType === 'File' && !IsChecksumIconsHided && clickedBucketItem.ChecksumStatus !== 'NotVerified'
              ) {
              <div class="horizantal-display">
                <button
                  mat-icon-button
                  matTooltipClass="tooltip-style"
                  matTooltipPosition="above"
                  [matTooltip]="'Copy'"
                  rippleOnHover (click)="copyToClipBoard()"
                  [attr.id]="buildControlId('btn-checksum-copy')">
                  <span class="icon-ic-copy"></span>
                </button>
                <button
                  mat-icon-button
                  matTooltipClass="tooltip-style"
                  matTooltipPosition="above"
                  [matTooltip]="'Regenerate Checksum'"
                  rippleOnHover (click)="regenerateChecksum()"
                  [attr.id]="buildControlId('btn-checksum-regenerate')"
                  >
                  <span class="icon-ic-regenerate"></span>
                </button>
              </div>
            }
          </div>
        }
      </div>

      @if (clickedBucketItem?.FolderType === 'File') {
        <div
          class="p-b-m"
          >
          <app-file-meta-data
            [clickedBucketItem]="clickedBucketItem"
          ></app-file-meta-data>
        </div>
      }



      @if (
        clickedBucketItem?.FolderType === 'StudyPackage' ||
        clickedBucketItem?.FolderType === 'FacilityPackage'
        ) {
        <div class="package-folder-section">
          <div class="form-label">Study Completion Date</div>
          <!-- Mat form field for Study Package -->
          @if (clickedBucketItem?.FolderType === 'StudyPackage' && !isFromSearch) {
            <mat-form-field class="studyCompletionDate w-100 p-b-m" appearance="outline"
              >
              <input matInput placeholder="DD MMM YYYY   (eg: 01 Jan 1970)" [matDatepicker]="picker" [max]="TodayMaxDate"
                [formControl]="studyCompletionDate" (keydown.Tab)="datePicker.close()"
                (keydown.Shift.Tab)="datePicker.close()" [attr.id]="buildControlId('fld-study-completion-date', 'editable')" />
                <mat-datepicker-toggle matIconSuffix [for]="picker"
                  [attr.id]="buildControlId('btn-study-completion-calendar-toggle', 'editable')">
                  <img matDatepickerToggleIcon src="./assets/images/application-logos/svg/ic-calendar.svg" />
                </mat-datepicker-toggle>
                <mat-datepicker #picker disabled="false"></mat-datepicker>
                @if (studyCompletionDate.errors?.required && !isFromSearch) {
                  <mat-error>
                    Enter a valid Study Completion Date
                  </mat-error>
                }
              </mat-form-field>
            }
            <!-- Mat form field for Ficility Package -->
            @if (clickedBucketItem?.FolderType === 'FacilityPackage' || isFromSearch) {
              <mat-form-field   class="studyCompletionDate w-100 p-b-m placeholder-margin" appearance="outline"
                >
                <input matInput disabled [placeholder]="placeHolder" [matDatepicker]="picker"
                  [attr.id]="buildControlId('fld-study-completion-date', 'readonly')" />
                  <mat-datepicker-toggle disabled matIconSuffix [for]="picker"
                    [attr.id]="buildControlId('btn-study-completion-calendar-toggle', 'readonly')"><img matDatepickerToggleIcon
                  src="./assets/images/application-logos/svg/ic-calendar.svg" /></mat-datepicker-toggle>
                </mat-form-field>
              }
              <!-- Retention Period -->
              <div class="form-label p-b-m">Retention Period</div>
              <div class="p-b-m row-container horizontal-center-align h-2rem icon-color">
                <div class="w-50Per">
                  <div class="form-label p-b-xs">Period</div>
                  @if (clickedBucketItem?.FolderType === 'StudyPackage') {
                    <span class="form-value">15 Years</span>
                  }
                  @if (clickedBucketItem?.FolderType === 'FacilityPackage') {
                    <span class="form-value">Indefinite</span>
                  }
                </div>
                <div class="w-50Per">
                  <div class="form-label p-b-xs">End Date</div>
                  @if (clickedBucketItem?.ArchivingEndDate !== null) {
                    <span
                      class="form-value">
                      {{clickedBucketItem.ArchivingEndDate}}
                    </span>
                  }
                  @if (clickedBucketItem?.ArchivingEndDate === null) {
                    <span
                      class="form-value"
                      >--</span
                      >
                  }
                </div>
              </div>
              @if (!(isFromSearch || fromRequesterPackageFolderPage)) {
                @if (clickedBucketItem?.FolderType === 'StudyPackage') {
                  <button mat-button color="accent" class="ghost w-100"
                    (click)="submitStudyCompletionDate()"
                    [attr.id]="buildControlId('btn-submit-study-completion-date')">
                    Submit
                  </button>
                }
              }
            </div>
          }
          @if (!(isFromSearch || fromRequesterPackageFolderPage)) {
            @if (clickedBucketItem?.FolderType === 'File' && selectedFolderCount <= 1) {
              <app-tags [initialValue]="tags" (selectedTag)="updateTags($event)"></app-tags>
            }
            <!-- Tags section for package folders -->
            @if ((clickedBucketItem?.FolderType === 'StudyPackage' || clickedBucketItem?.FolderType === 'FacilityPackage') && selectedFolderCount <= 1) {
              <div style="margin-bottom: 1rem;">
                <app-package-folder-tags-general
                  [initialValue]="tags"
                  [expandTags]="false"
                  [isFromGeneralInformation]="true"
                  (tagsUpdated)="onPackageFolderTagsUpdated($event)">
                </app-package-folder-tags-general>
              </div>
            }
          }
        </div>
      </div>
